<template>
  <tr class="participants-swaps-item-row">
    <td class="participants-swaps-item-col">
      <a
        class="participants-swaps-item__name"
        @click="$emit('to-swap', swap.id)"
      >
        <h4 class="participants-swaps-item__title">
          {{ swap.goal }}
        </h4>
        <p class="participants-swaps-item__description" v-if="swap.description">
          {{ swap.description }}
        </p>
      </a>
    </td>
    <td class="participants-swaps-item-col">
      <div class="d-flex flex-column bhGray2--text">
        <strong class="text-nowrap">
          {{ swapCategory }}
        </strong>
        <span class="text-nowrap">
          {{ swap.difficultLevel | lowerCased }} &
          {{ swap.impactLevel | lowerCased }} impact
        </span>
      </div>
    </td>
    <td class="participants-swaps-item-col">
      <span
        :class="
          `participants-swaps-item__status-badge participants-swaps-item__status-badge--${swap.status}`
        "
        >{{ swapStatus }}</span
      >
    </td>
    <td class="participants-swaps-item-col">
      <span class="bhGray2--text text-nowrap">
        {{ swap.lastModifiedDate | moment('MM/DD/YY') }}
      </span>
    </td>
    <td class="participants-swaps-item-col">
      <span class="text-nowrap bhGray2--text">
        <strong>
          {{ swap.repeatGoal }}
        </strong>
      </span>
    </td>
    <td class="participants-swaps-item-col">
      <span class="text-nowrap bhGray2--text">
        <strong>
          {{ swap.repeatState }}
        </strong>
      </span>
    </td>
    <td class="participants-swaps-item-col">
      <v-progress-circular
        :size="50"
        :width="6"
        :color="progressColor"
        :value="swapProgress"
      >
        <v-icon :size="25" :color="progressColor" v-if="swap.status === 'DONE'"
          >bhi-check</v-icon
        >
        <span
          :class="
            `participants-swaps-item__progress-label ${progressColor}--text`
          "
          v-else
        >
          {{ swapProgress }}%
        </span>
      </v-progress-circular>
    </td>
    <td class="participants-swaps-item-col">
      <v-btn
        icon
        color="accent"
        elevation="0"
        @click="$emit('to-swap', swap.id)"
      >
        <v-icon>mdi-arrow-right</v-icon>
      </v-btn>
    </td>
  </tr>
</template>

<script>
import { swapCategoryName, swapStatusName } from '@/helpers/swapCategoryName'

export default {
  name: 'ParticipantSwapsTableRow',
  mixins: [],
  components: {},
  filters: {
    lowerCased: function(data = '') {
      return data.toLowerCase()
    },
  },
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {}
  },
  methods: {
    swapCategoryName,
    swapStatusName,
  },
  computed: {
    swap() {
      return this.user
    },
    swapCategory() {
      return this.swapCategoryName(
        this.swap.difficultLevel,
        this.swap.impactLevel,
      )
    },
    swapStatus() {
      return this.swapStatusName(this.swap.status)
    },
    swapProgress() {
      if (this.swap.repeatGoal === 0) return 100
      const percentage = Math.round(
        (this.swap.repeatState / this.swap.repeatGoal) * 100,
      )
      return percentage
    },
    progressColor() {
      if (this.swapProgress <= 0) return 'bhGray2'
      if (this.swapProgress >= 100) return 'bhGreenDark'
      return 'accent'
    },
  },
}
</script>

<style lang="scss">
.participants-swaps-item {
  &-row {
    border-radius: $border-radius-root * 2;
    background: transparent !important;
    overflow: hidden;
    box-shadow: 0 8px 24px 0 rgba(0, 0, 0, 0.04);

    td {
      border-bottom: none !important;
      padding: 8px !important;

      &:first-of-type {
        padding-left: 24px !important;
      }
      &:last-of-type {
        padding-right: 24px !important;
      }
    }
  }

  &__status-badge {
    display: inline-block;
    white-space: nowrap;
    padding: 4px;
    font-size: 12px;
    line-height: 16px;
    border-radius: 4px;
    font-weight: 500;

    &--NEW {
      color: #704863;
      background-color: #efe6ec;
    }

    &--IN_PROGRESS {
      color: #19647e;
      background-color: #ccebf5;
    }

    &--DONE {
      color: #50701f;
      background-color: #e4f2cf;
    }

    &--REJECTED {
      color: #ffffff;
      background-color: var(--bh-red--light);
    }
  }

  &__title {
    margin-bottom: 0 !important;
    font-size: 16px;
    line-height: 24px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    max-width: 350px;
  }

  &__description {
    color: #000;
    font-size: 12px;
    line-height: 16px;
    margin-bottom: 0 !important;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 350px;
  }

  &__progress-label {
    font-size: 14px;
    font-weight: 700;
    line-height: 16px;
  }
}
</style>
